import { render, staticRenderFns } from "./InterRichText.vue?vue&type=template&id=f6dfb6a2&scoped=true"
import script from "./InterRichText.vue?vue&type=script&lang=js"
export * from "./InterRichText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dfb6a2",
  null
  
)

export default component.exports